import { render, staticRenderFns } from "./TableRatePlanSidebarItem.vue?vue&type=template&id=13534976&scoped=true&"
import script from "./TableRatePlanSidebarItem.vue?vue&type=script&lang=js&"
export * from "./TableRatePlanSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13534976",
  null
  
)

export default component.exports